import React from "react";

// The cafe/creator sales page is a fully self-contained static document
// (its own <head>, fonts and CSS). We render it in a full-viewport iframe so
// its styles are completely isolated from the main app while the URL stays /begin.
export default function BeginPage() {
  return (
    <iframe
      title="Soma Lixir — For Cafe Owners & Creators"
      src="/begin-sales.html"
      style={{
        position: "fixed",
        inset: 0,
        width: "100%",
        height: "100%",
        border: "none",
      }}
    />
  );
}
